module.exports = __webpack_public_path__ + "static/media/logo-precidia-rentals-green.6b245a63.png";